import { VStack } from "@chakra-ui/react";
import { Form, Formik, FormikConfig } from "formik";
import { FC } from "react";
import * as yup from "yup";

import { FormControl } from "~/src/components/common/forms/FormControl";
import { FormControlGroup } from "~/src/components/common/forms/FormControlGroup";
import { FormikFormButtons } from "~/src/components/common/forms/FormikFormButtons";
import { FormikTimeField } from "~/src/components/common/forms/FormikTimeField";

export type FormValues = {
  startTime: Date | null;
  endTime: Date | null;
};

export type Props = {
  initialValues: FormValues;
  onSubmit: FormikConfig<FormValues>["onSubmit"];
  onCancel: () => void;
};

const validationSchema = yup.object({
  startTime: yup
    .date()
    .typeError("無効な時刻です。正しい時刻を入力してください。")
    .nullable(),
  endTime: yup
    .date()
    .typeError("無効な時刻です。正しい時刻を入力してください。")
    .nullable(),
});

export const ScheduleForm: FC<Props> = ({
  initialValues,
  onSubmit,
  onCancel,
}) => {
  return (
    <Formik<FormValues>
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount={false}
      onSubmit={onSubmit}
    >
      <Form>
        <VStack spacing="24px" alignItems="flex-start">
          <FormControlGroup>
            <FormControl label="開始時刻">
              <FormikTimeField name="startTime" placeholder="開始時刻" />
            </FormControl>
            <FormControl label="終了時刻">
              <FormikTimeField name="endTime" placeholder="終了時刻" />
            </FormControl>
          </FormControlGroup>
          <FormikFormButtons onCancelClick={onCancel} />
        </VStack>
      </Form>
    </Formik>
  );
};
